import { lt } from '@mews/framework';
import { Button, Dialog } from '@optimus-web/core';

interface DeletedBillDialogProps {
    active: boolean;
    onClose: () => void;
}
export const DeletedBillDialog = ({ active, onClose }: DeletedBillDialogProps) => (
    <Dialog
        title={lt('LedgersTableDeletedBillDialogTitle')}
        size="small"
        active={active}
        onClose={onClose}
        footer={{
            primary: (
                <Button size="medium" variant="primary" onClick={onClose} type="button">
                    {lt('Ok')}
                </Button>
            ),
        }}
    >
        {lt('LedgersTableDeletedBillDialogContent')}
    </Dialog>
);
